import { render, staticRenderFns } from "./change_language.vue?vue&type=template&id=9e483664"
import script from "./change_language.vue?vue&type=script&lang=js"
export * from "./change_language.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports